import http from 'utils/http'

const getStripeConfig = payload =>
  http.post('/payment/v1/stripe/config', payload)

const getCards = () => http.get('/payment/v1/stripe/card-list')

const deleteCard = cardId => http.delete(`/payment/v1/stripe/delete-card/${cardId}`)

const pay = payload => http.post('/payment/v1/stripe/pay/card-saved', payload)

export default {
  getStripeConfig,
  getCards,
  deleteCard,
  pay
}



// WEBPACK FOOTER //
// ./src/services/paymentService.js